import { createFileRoute, redirect } from "@tanstack/react-router";
import { localePath, normalizeLocale } from "@/lib/i18n";

export const Route = createFileRoute("/{-$locale}/registration")({
  staticData: { sitemap: false },
  beforeLoad: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    throw redirect({ href: localePath(locale, "/registration-demo"), statusCode: 301 });
  },
});
